// Keep in sync with backend/src/config/approval.js (ZIM_PROVINCES / ZIM_DISTRICTS).
export const ZIM_PROVINCES = [
  'Bulawayo', 'Harare', 'Manicaland', 'Mashonaland Central', 'Mashonaland East',
  'Mashonaland West', 'Masvingo', 'Matabeleland North', 'Matabeleland South', 'Midlands',
];

export const ZIM_DISTRICTS = {
  // Metro provinces: administrative "districts" are too coarse, so these lists
  // double as suburb/area suggestions. The District field is free-text too, so
  // anything not listed can still be typed.
  Bulawayo: [
    'Barbourfields', 'Bradfield', 'Cowdray Park', 'Emakhandeni', 'Emganwini', 'Entumbane',
    'Famona', 'Hillcrest', 'Hillside', 'Khumalo', 'Kumalo', 'Lobengula', 'Luveve',
    'Magwegwe', 'Mahatshula', 'Makokoba', 'Mpopoma', 'Mzilikazi', 'Nketa', 'Nkulumane',
    'Northend', 'Nguboyenja', 'Pelandaba', 'Pumula', 'Riverside', 'Selborne Park',
    'Suburbs', 'Tshabalala', 'Waterford', 'Bulawayo Central',
  ],
  Harare: [
    'Avondale', 'Belvedere', 'Borrowdale', 'Budiriro', 'Chitungwiza', 'Dzivarasekwa',
    'Eastlea', 'Epworth', 'Glen Norah', 'Glen View', 'Greendale', 'Greystone Park',
    'Hatcliffe', 'Hatfield', 'Highfield', 'Highlands', 'Kuwadzana', 'Mabelreign',
    'Marlborough', 'Mbare', 'Milton Park', 'Mount Pleasant', 'Msasa', 'Mufakose',
    'Norton', 'Ruwa', 'Strathaven', 'Sunningdale', 'Tafara', 'Warren Park', 'Waterfalls',
    'Harare Rural', 'Harare Urban',
  ],
  Manicaland: ['Buhera', 'Chimanimani', 'Chipinge Rural', 'Chipinge Urban', 'Makoni', 'Mutare Rural', 'Mutare Urban', 'Mutasa', 'Nyanga', 'Rusape'],
  'Mashonaland Central': ['Bindura Rural', 'Bindura Urban', 'Guruve', 'Mazowe', 'Mbire', 'Mount Darwin', 'Muzarabani', 'Mvurwi', 'Rushinga', 'Shamva'],
  'Mashonaland East': ['Chikomba', 'Goromonzi', 'Hwedza', 'Marondera Rural', 'Marondera Urban', 'Mudzi', 'Murehwa', 'Mutoko', 'Ruwa', 'Seke', 'Uzumba-Maramba-Pfungwe'],
  'Mashonaland West': ['Chegutu Rural', 'Chegutu Urban', 'Chinhoyi', 'Hurungwe', 'Kadoma Urban', 'Kariba Rural', 'Kariba Urban', 'Karoi', 'Makonde', 'Mhondoro-Ngezi', 'Norton', 'Sanyati', 'Zvimba'],
  Masvingo: ['Bikita', 'Chiredzi Rural', 'Chiredzi Urban', 'Chivi', 'Gutu', 'Masvingo Rural', 'Masvingo Urban', 'Mwenezi', 'Zaka'],
  'Matabeleland North': ['Binga', 'Bubi', 'Hwange Rural', 'Hwange Urban', 'Lupane', 'Nkayi', 'Tsholotsho', 'Umguza', 'Victoria Falls'],
  'Matabeleland South': ['Beitbridge Rural', 'Beitbridge Urban', 'Bulilima', 'Gwanda Rural', 'Gwanda Urban', 'Insiza', 'Mangwe Rural', 'Mangwe Urban', 'Matobo', 'Umzingwane'],
  Midlands: ['Chirumhanzu', 'Gokwe North', 'Gokwe South', 'Gokwe Urban', 'Gweru Rural', 'Gweru Urban', 'Kwekwe Rural', 'Kwekwe Urban', 'Mberengwa', 'Redcliff', 'Shurugwi Rural', 'Shurugwi Urban', 'Zvishavane Rural', 'Zvishavane Urban'],
};

const _provinces = { ZIM_PROVINCES, ZIM_DISTRICTS };
export default _provinces;
